import React from 'react';
import Navbar from '../components/navbar';
import profilepic from "../assets/profilepic.png";
import Project from '../components/Project';
import Skills from '../components/Skills';
import Experience from '../components/Experience';
import Footer from '../components/Footer';
function Home() {
  return (
    <div className="home-container">
      <Navbar />
      <section className="home" id="home">
        <div className="home-content">
          <div className="home-text">
            <h1>Hi, I'm <span>Gabriel Samson</span></h1>
            <h2>Information Technology Graduate</h2>
            <p>
              I build efficient, modern, and user-friendly <br />
              web applications.
            </p>
          </div>

          <div className="home-image">
            <img className="profilepic" src={profilepic} alt="Profile" />
          </div>
        </div>
      </section>
      <Project/>
      <Skills/>
      <Experience/>
      <Footer/>
    </div>

  );
}

export default Home;
